<template>
  <div class="layout-content">
    <div class="m-slider">
      <vue-swiper :banners="promotionBanners" />
    </div>
    <div class="notice">
      <div class="notice__content">
        <em>
          <img src="@/assets/style/img/index/iconPlacard@2x.png" alt="">
        </em>
        <div class="marquee">
          <marquee>{{ marquee }}</marquee>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="recommend">
        <div class="menu-slider">
          <nuxt-link class="menu-slider__item" to="/m/lmtj/jspk10">
            <img class="slider-img" src="@/assets/style/img/index-co168/recommend-lot--icon1@2x.png" alt="">
            <span class="slider-text">两面推荐</span>
          </nuxt-link>
          <nuxt-link class="menu-slider__item" to="/m/expert/jspk10">
            <img class="slider-img" src="@/assets/style/img/index-co168/recommend-lot--icon2@2x.png" alt="">
            <span class="slider-text">专家推荐</span>
          </nuxt-link>
          <nuxt-link class="menu-slider__item" to="/m/changltx">
            <img class="slider-img" src="@/assets/style/img/index-co168/recommend-lot--icon3@2x.png" alt="">
            <span class="slider-text">长龙提醒</span>
          </nuxt-link>
          <nuxt-link class="menu-slider__item" to="/m/shjh/jspk10">
            <img class="slider-img" src="@/assets/style/img/index-co168/recommend-lot--icon4@2x.png" alt="">
            <span class="slider-text">杀号计划</span>
          </nuxt-link>
          <nuxt-link class="menu-slider__item" to="/m/buyplan/jspk10">
            <img class="slider-img" src="@/assets/style/img/index-co168/recommend-lot--icon5@2x.png" alt="">
            <span class="slider-text">购彩计划</span>
          </nuxt-link>
          <!-- <a v-if="!hideAppDownloadIcon && !hideAppDownloadIconForIOs" class="menu-slider__item" :href="qrcodeURL">
            <img class="slider-img" src="@/assets/style/img/index-co168/recommend-lot--icon6@2x.png" alt="">
            <span class="slider-text">彩票软件</span>
          </a>

          <a v-if="hideAppDownloadIcon" class="menu-slider__item">
            <img class="slider-img" src="" alt="">
            <span class="slider-text"></span>
          </a>

          <a class="menu-slider__item fn-invisible">
            <img class="slider-img" src="" alt="">
            <span class="slider-text"></span>
          </a>

          <a class="menu-slider__item fn-invisible">
            <img class="slider-img" src="" alt="">
            <span class="slider-text"></span>
          </a> -->
        </div>
      </div>
    </div>
    <!-- promo -->
    <div class="promo-banner">
      <div class="promo-banner__item -m card ck-content">
        <div class="pb-ct -m" v-html="topAd"></div>
      </div>
      <div class="promo-banner__item -m card ck-content">
        <div class="pb-ct -m" v-html="bottomAd"></div>
      </div>
    </div>
    <div class="lot-list-box">
      <template v-for="(item, key) in drawInfoList">
        <lottery-item :key="key" :draw-info-detail="item" :lottery-code="key" />
      </template>
    </div>
  </div>
</template>

<script>
import { getBatchDetailDrawInfo_mobile } from '@/api/mobile/basic'
import VueSwiper from '@/components/mobile/common/index/VueSwiper'
import LotteryItem from '@/components/mobile/common/LotteryItem'
import { isPDSWAPP } from '@/utils/commonLib'

import get from 'lodash.get'

export default {
  layout: 'mobile/default',
  name: 'WapHome',
  components: {
    VueSwiper,
    LotteryItem
  },
  data() {
    return {
      promotionBanners: [],
      marquee: '',
      drawInfoList: {},
      hideAppDownloadIcon: false,
      hideAppDownloadIconForIOs: false,
      topAd: '',
      bottomAd: ''
    }
  },
  computed: {
    siteInfo() {
      return this.$store.state.site.siteInfo
    },
    qrcodeURL() {
      return this.siteInfo.siteSetting.apkLink ? get(this, 'siteInfo.siteSetting.apkLink.url', '') : ''
    }
  },
  async created() {
    const [lotteryMap, mapError] = await this.$store.dispatch('lottery/getLotteryNameMapping')
    if (mapError) return

    await this.$store.dispatch('site/getSiteInfo')
    this.promotionBanners = this.siteInfo.siteSetting.promotionBanners
    this.marquee = this.siteInfo.siteSetting.marquee
    await this.getBatchDetailDrawInfo(lotteryMap)
  },
  mounted() {
    this.hideAppDownloadIcon = isPDSWAPP()
    this.hideAppDownloadIconForIOs = this.isIos()
    this.topAd = this.DOMdecode(this.siteInfo.siteSetting.topAd)
    this.bottomAd = this.DOMdecode(this.siteInfo.siteSetting.bottomAd)
  },
  methods: {
    isIos() {
      return navigator.userAgent.includes('iPhone')
    },
    async getBatchDetailDrawInfo(publicCpMap) {
      let cpCodeList = get(this, 'siteInfo.siteSetting.hotLottery', null)
      if (!cpCodeList) {
        console.warn('getBatchDetailDrawInfo: siteInfo 缺少hotLottery 資料!')
        cpCodeList = []
      }

      // 特殊處理: 儲存在siteSetting 裡的hotLottery 並不會隨著publicCp 的刪減做過濾
      // 所以由前端處理這一手、將publicCp 和hotLottery 做交集
      cpCodeList = cpCodeList.filter((lotteryCode) => publicCpMap[lotteryCode])

      const [drawInfoList, error] = await getBatchDetailDrawInfo_mobile(cpCodeList)
      if (error) return

      const mappingDrawInfoList = {}
      cpCodeList.forEach(code => {
        mappingDrawInfoList[code] = drawInfoList[code]
      })
      this.drawInfoList = mappingDrawInfoList
    },
    DOMdecode(str) {
      const txt = new DOMParser().parseFromString(str, 'text/html')
      return txt.documentElement.textContent
    }
  }
}
</script>

<style scoped>
.fn-invisible {
  opacity: 0;
  pointer-events: none;
}
</style>
